<template>
  <div v-if="data">
    <Top />
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-sm">
          <div class="clearfix"></div>
          <br />
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <!-- Föräldrar -->
        <div class="col-md-6" v-if="type === 'parents'">
          <h2 class="text-primary-fh left-header" v-html="data.familytreedashboard.parentsHeader"></h2>
          <p v-html="data.familytreedashboard.buildParentsText"></p>
          <!-- Mamma -->
          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-primary-fh">Mamma</h5>
              <label>Förnamn</label>
              <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Förnamn"
                v-model="parents.mother.firstName" v-on:keypress="isLetterOrHyphen($event)" />
              <div class="clearfix"></div>
              <label>Efternamn</label>
              <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Efternamn"
                v-model="parents.mother.lastName" v-on:keypress="isLetterOrHyphen($event)" />
              <div class="clearfix"></div>
              <label for="btn-group">Är hon i livet?</label><br />
              <div class="btn-group btn-group-toggle">
                <label class="btn btn-outline-secondary btn-lg btn-override btn-alive"
                  :class="parents.mother.alive === true ? 'active': ''">
                  <input type="radio" v-model="parents.mother.alive" v-bind:value="true" autocomplete="off">Ja
                </label>
                <label class="btn btn-outline-secondary btn-lg btn-override btn-alive"
                  :class="parents.mother.alive === false ? 'active': ''">
                  <input type="radio" v-model="parents.mother.alive" v-bind:value="false" autocomplete="off">Nej
                </label>
              </div>
            </div>
          </div>
          <!-- Mormor -->
          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-primary-fh">Mormor</h5>
              <label>Förnamn</label>
              <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Förnamn"
                v-model="grandParents.grandmother.firstName" v-on:keypress="isLetterOrHyphen($event)" />
              <div class="clearfix"></div>
              <label>Efternamn</label>
              <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Efternamn"
                v-model="grandParents.grandmother.lastName" v-on:keypress="isLetterOrHyphen($event)" />
              <div class="clearfix"></div>
              <label for="btn-group">Är hon i livet?</label><br />
              <div class="btn-group btn-group-toggle">
                <label class="btn btn-outline-secondary btn-lg btn-override btn-alive"
                  :class="grandParents.grandmother.alive === true ? 'active': ''">
                  <input type="radio" v-model="grandParents.grandmother.alive" v-bind:value="true" autocomplete="off">Ja
                </label>
                <label class="btn btn-outline-secondary btn-lg btn-override btn-alive"
                  :class="grandParents.grandmother.alive === false ? 'active': ''">
                  <input type="radio" v-model="grandParents.grandmother.alive" v-bind:value="false" autocomplete="off">Nej
                </label>
              </div>
            </div>
          </div>
          <!-- Morfar -->
          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-primary-fh">Morfar</h5>
              <label>Förnamn</label>
              <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Förnamn"
                v-model="grandParents.grandfather.firstName" v-on:keypress="isLetterOrHyphen($event)" />
              <div class="clearfix"></div>
              <label>Efternamn</label>
              <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Efternamn"
                v-model="grandParents.grandfather.lastName" v-on:keypress="isLetterOrHyphen($event)" />
              <div class="clearfix"></div>
              <label for="btn-group">Är han i livet?</label><br />
              <div class="btn-group btn-group-toggle">
                <label class="btn btn-outline-secondary btn-lg btn-override btn-alive"
                  :class="grandParents.grandfather.alive === true ? 'active': ''">
                  <input type="radio" v-model="grandParents.grandfather.alive" v-bind:value="true" autocomplete="off">Ja
                </label>
                <label class="btn btn-outline-secondary btn-lg btn-override btn-alive"
                  :class="grandParents.grandfather.alive === false ? 'active': ''">
                  <input type="radio" v-model="grandParents.grandfather.alive" v-bind:value="false" autocomplete="off">Nej
                </label>
              </div>
            </div>
          </div>
          <!-- Pappa -->
          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-primary-fh">Pappa</h5>
              <label>Förnamn</label>
              <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Förnamn"
                v-model="parents.father.firstName" v-on:keypress="isLetterOrHyphen($event)" />
              <div class="clearfix"></div>
              <label>Efternamn</label>
              <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Efternamn"
                v-model="parents.father.lastName" v-on:keypress="isLetterOrHyphen($event)" />
              <div class="clearfix"></div>
              <label for="btn-group">Är han i livet?</label><br />
              <div class="btn-group btn-group-toggle">
                <label class="btn btn-outline-secondary btn-lg btn-override btn-alive"
                  :class="parents.father.alive === true ? 'active': ''">
                  <input type="radio" v-model="parents.father.alive" v-bind:value="true" autocomplete="off">Ja
                </label>
                <label class="btn btn-outline-secondary btn-lg btn-override btn-alive"
                  :class="parents.father.alive === false ? 'active': ''">
                  <input type="radio" v-model="parents.father.alive" v-bind:value="false" autocomplete="off">Nej
                </label>
              </div>
            </div>
          </div>
          <!-- Farmor -->
          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-primary-fh">Farmor</h5>
              <label>Förnamn</label>
              <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Förnamn"
                v-model="grandParents.grandma.firstName" v-on:keypress="isLetterOrHyphen($event)" />
              <div class="clearfix"></div>
              <label>Efternamn</label>
              <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Efternamn"
                v-model="grandParents.grandma.lastName" v-on:keypress="isLetterOrHyphen($event)" />
              <div class="clearfix"></div>
              <label for="btn-group">Är hon i livet?</label><br />
              <div class="btn-group btn-group-toggle">
                <label class="btn btn-outline-secondary btn-lg btn-override btn-alive"
                  :class="grandParents.grandma.alive === true ? 'active': ''">
                  <input type="radio" v-model="grandParents.grandma.alive" v-bind:value="true" autocomplete="off">Ja
                </label>
                <label class="btn btn-outline-secondary btn-lg btn-override btn-alive"
                  :class="grandParents.grandma.alive === false ? 'active': ''">
                  <input type="radio" v-model="grandParents.grandma.alive" v-bind:value="false" autocomplete="off">Nej
                </label>
              </div>
            </div>
          </div>
          <!-- Farfar -->
          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-primary-fh">Farfar</h5>
              <label>Förnamn</label>
              <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Förnamn"
                v-model="grandParents.grandpa.firstName" v-on:keypress="isLetterOrHyphen($event)" />
              <div class="clearfix"></div>
              <label>Efternamn</label>
              <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Efternamn"
                v-model="grandParents.grandpa.lastName" v-on:keypress="isLetterOrHyphen($event)" />
              <div class="clearfix"></div>
              <label for="btn-group">Är han i livet?</label><br />
              <div class="btn-group btn-group-toggle">
                <label class="btn btn-outline-secondary btn-lg btn-override btn-alive"
                  :class="grandParents.grandpa.alive === true ? 'active': ''">
                  <input type="radio" v-model="grandParents.grandpa.alive" v-bind:value="true" autocomplete="off">Ja
                </label>
                <label class="btn btn-outline-secondary btn-lg btn-override btn-alive"
                  :class="grandParents.grandpa.alive === false ? 'active': ''">
                  <input type="radio" v-model="grandParents.grandpa.alive" v-bind:value="false" autocomplete="off">Nej
                </label>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block btn-finish-relation"
          @click="finishedRelation('parents')" :disabled="dirty">Klar</button>
        </div>
        <!-- Barn -->
        <div class="col-md-6" v-if="type === 'children'">
          <h2 class="text-primary-fh left-header" v-html="data.familytreedashboard.buildchildrenheader"></h2>
          <p v-html="data.familytreedashboard.buildChildrenText"></p>
          <!-- Minderårig -->
          <div class="card-preview minor-age-card">
            <p>Jag har barn under 13 år
              &nbsp; &nbsp; &nbsp; &nbsp;
              <input
                class="form-check-input minor-age-checkbox"
                type="checkbox"
                @change="minorAgedChildren()"
                v-model="minorAge"
              >
            </p>
          </div>
          <div class="card-preview" v-if="children.length < 1">
            <h5 class="text-center card-preview-header">Inga barn tillagda</h5>
          </div>
          <!-- Om man har barn -->
          <div class="parent" v-for="(c, i) in children" v-bind:key="i">
            <div class="card child-card">
              <div class="card-body">
                <span v-on:click="removeRelative(children, i)" class="close">&times;</span>
                <small class="text-primary-fh pull-right">Barn</small>
                <label>Förnamn</label>
                <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Förnamn"
                  v-model="c.firstName" v-on:keypress="isLetterOrHyphen($event)" />
                <div class="clearfix"></div>
                <label>Efternamn</label>
                <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Efternamn"
                  v-model="c.lastName" v-on:keypress="isLetterOrHyphen($event)" />
                <div class="clearfix"></div>
                <label for="btn-group">Är barnet i livet?</label><br />
                <div class="btn-group btn-group-toggle" style="display: flex">
                  <label class="btn btn-outline-secondary btn-lg btn-override btn-alive" style="background: #fff"
                    :class="c.alive === true ? 'active': ''">
                    <input type="radio" v-model="c.alive" v-bind:value="true" autocomplete="off">Ja
                  </label>
                  <label class="btn btn-outline-secondary btn-lg btn-override btn-alive" style="background: #fff"
                    :class="c.alive === false ? 'active': ''">
                    <input type="radio" v-model="c.alive" v-bind:value="false" autocomplete="off">Nej
                  </label>
                </div>
                <div class="clearfix"></div>
                <button class="btn btn-primary btn-lg btn-block add-grandchild-btn" @click="addGrandChild(i)">
                  Lägg till barnbarn
                </button>
              </div>
            </div>
          </div>
          <div class="parent" v-for="(gc, i) in grandChildren" v-bind:key="'gc-' + i">
            <div class="card override-card">
              <div class="card-body override-card-body">
                <span v-on:click="removeRelative(grandChildren, i)" class="close">&times;</span>
                <small class="text-primary-fh pull-right">Barnbarn | Tillhör: <strong>{{ getNameByNode(gc.familyTreeParentNode) }}</strong></small>
                <label>Förnamn</label>
                <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Förnamn"
                  v-model="gc.firstName" v-on:keypress="isLetterOrHyphen($event)" />
                <div class="clearfix"></div>
                <label>Efternamn</label>
                <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Efternamn"
                  v-model="gc.lastName" v-on:keypress="isLetterOrHyphen($event)" />
                <div class="clearfix"></div>
                <label for="btn-group">Är barnbarnet i livet?</label><br />
                <div class="btn-group btn-group-toggle" style="display: flex">
                  <label class="btn btn-outline-secondary btn-lg btn-override btn-alive" style="background: #fff"
                    :class="gc.alive === true ? 'active': ''">
                    <input type="radio" v-model="gc.alive" v-bind:value="true" autocomplete="off">Ja
                  </label>
                  <label class="btn btn-outline-secondary btn-lg btn-override btn-alive" style="background: #fff"
                    :class="gc.alive === false ? 'active': ''">
                    <input type="radio" v-model="gc.alive" v-bind:value="false" autocomplete="off">Nej
                  </label>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block add-child-btn" @click="addChild()">
            Lägg till barn
          </button>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block btn-finish-relation"
            @click="finishedRelation('children')" v-if="children.length >= 1" :disabled="dirty">Klar</button>
          <div class="clearfix"></div>
            <button v-if="children.length < 1"
              class="btn btn-primary btn-lg btn-block" @click="noRelatives('children')">
            Jag har inga biologiska barn
            </button>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="consentMinorModal" role="dialog" aria-labelledby="consentMinorModalLabel" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="consentMinorModalLabel" v-html="data.familytree.consentMinorHeader"></h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body" v-html="data.familytree.consentMinorText"></div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Avbryt</button>
                <button type="button" class="btn btn-success" @click="giveConsentFinishRelation(true)">Godkänn</button>
              </div>
            </div>
          </div>
        </div>
        <!-- Syskon -->
        <div class="col-md-6" v-if="type === 'siblings'">
          <h2 class="text-primary-fh left-header" v-html="data.familytreedashboard.buildsiblingsheader"></h2>
          <p v-html="data.familytreedashboard.buildSiblingsText"></p>
          <div class="card-preview" v-if="siblings.length < 1">
            <h5 class="text-center card-preview-header">Inga helsyskon tillagda</h5>
          </div>
          <!-- Om man har syskon -->
          <div>
            <div class="parent" v-for="(s, i) in siblings" v-bind:key="i">
              <div class="card siblings-card">
                <div class="card-body">
                  <span v-on:click="removeRelative(siblings, i)" class="close">&times;</span>
                  <small class="text-primary-fh pull-right">Syskon</small>
                  <label>Förnamn</label>
                  <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Förnamn"
                    v-model="s.firstName" v-on:keypress="isLetterOrHyphen($event)" />
                  <div class="clearfix"></div>
                  <label>Efternamn</label>
                  <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Efternamn"
                    v-model="s.lastName" v-on:keypress="isLetterOrHyphen($event)" />
                  <div class="clearfix"></div>
                  <label for="btn-group">Är ditt helsyskon i livet?</label><br />
                  <div class="btn-group btn-group-toggle" style="display: flex">
                    <label class="btn btn-outline-secondary btn-lg btn-override btn-alive" style="background: #fff"
                      :class="s.alive === true ? 'active': ''">
                      <input type="radio" v-model="s.alive" v-bind:value="true" autocomplete="off">Ja
                    </label>
                    <label class="btn btn-outline-secondary btn-lg btn-override btn-alive" style="background: #fff"
                      :class="s.alive === false ? 'active': ''">
                      <input type="radio" v-model="s.alive" v-bind:value="false" autocomplete="off">Nej
                    </label>
                  </div>
                  <div class="clearfix"></div>
                  <button class="btn btn-primary btn-lg btn-block add-siblingsChild-btn" @click="addSiblingsChild(i)">
                    Lägg till syskonbarn
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="parent" v-for="(n, i) in siblingsChildren" v-bind:key="i">
              <div class="card override-card">
                <div class="card-body override-card-body">
                  <span v-on:click="removeRelative(siblingsChildren, i)" class="close">&times;</span>
                  <small class="text-primary-fh pull-right">Syskonbarn | Tillhör: <strong>{{ getNameByNode(n.familyTreeParentNode) }}</strong></small>
                  <label>Förnamn</label>
                  <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Förnamn"
                    v-model="n.firstName" v-on:keypress="isLetterOrHyphen($event)" />
                  <div class="clearfix"></div>
                  <label>Efternamn</label>
                  <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Efternamn"
                    v-model="n.lastName" v-on:keypress="isLetterOrHyphen($event)" />
                  <div class="clearfix"></div>
                  <label for="btn-group">Är ditt syskonbarn i livet?</label><br />
                  <div class="btn-group btn-group-toggle" style="display: flex">
                    <label class="btn btn-outline-secondary btn-lg btn-override btn-alive" style="background: #fff"
                      :class="n.alive === true ? 'active': ''">
                      <input type="radio" v-model="n.alive" v-bind:value="true" autocomplete="off">Ja
                    </label>
                    <label class="btn btn-outline-secondary btn-lg btn-override btn-alive" style="background: #fff"
                      :class="n.alive === false ? 'active': ''">
                      <input type="radio" v-model="n.alive" v-bind:value="false" autocomplete="off">Nej
                    </label>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block add-siblings-btn" @click="addSibling()">
            Lägg till helsyskon
          </button>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block btn-finish-relation" :disabled="dirty"
            @click="finishedRelation('siblings')" v-if="siblings.length >= 1">
            Klar
            </button>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block" @click="noRelatives('siblings')" v-if="siblings.length < 1">
            Jag har inga helsyskon
          </button>
        </div>
        <!-- Halvsyskon på mammas sida -->
        <div class="col-md-6" v-if="type === 'motherhalfsiblings'">
          <h2 class="text-primary-fh left-header" v-html="data.familytreedashboard.buildmotherhalfsiblingsheader"></h2>
          <p v-html="data.familytreedashboard.buildMotherhalfsiblingsText"></p>
          <div class="card-preview" v-if="motherHalfSiblings.length < 1">
            <h5 class="text-center card-preview-header">Inga halvsyskon på mammas sida tillagda</h5>
          </div>
          <!-- Om man har halvsyskon -->
          <div>
            <div class="parent" v-for="(mhs, i) in motherHalfSiblings" v-bind:key="i">
              <div class="card motherhalfsiblings-card">
                <div class="card-body">
                  <span v-on:click="removeRelative(motherHalfSiblings, i)" class="close">&times;</span>
                  <small class="text-primary-fh pull-right">Halvsyskon</small>
                  <label>Förnamn</label>
                  <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Förnamn"
                    v-model="mhs.firstName" v-on:keypress="isLetterOrHyphen($event)" />
                  <div class="clearfix"></div>
                  <label>Efternamn</label>
                  <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Efternamn"
                    v-model="mhs.lastName" v-on:keypress="isLetterOrHyphen($event)" />
                  <div class="clearfix"></div>
                  <label for="btn-group">Är halvsyskonet i livet?</label><br />
                  <div class="btn-group btn-group-toggle" style="display: flex">
                    <label class="btn btn-outline-secondary btn-lg btn-override btn-alive" style="background: #fff"
                      :class="mhs.alive === true ? 'active': ''">
                      <input type="radio" v-model="mhs.alive" v-bind:value="true" autocomplete="off">Ja
                    </label>
                    <label class="btn btn-outline-secondary btn-lg btn-override btn-alive" style="background: #fff"
                      :class="mhs.alive === false ? 'active': ''">
                      <input type="radio" v-model="mhs.alive" v-bind:value="false" autocomplete="off">Nej
                    </label>
                  </div>
                  <div class="clearfix"></div>
                  <button class="btn btn-primary btn-lg btn-block add-motherhalfcousins-btn" @click="addMotherHalfCousin(i)">
                    Lägg till barn till halvsyskon
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="parent" v-for="(mhc, i) in motherHalfCousins" v-bind:key="i">
              <div class="card override-card">
                <div class="card-body override-card-body">
                  <span v-on:click="removeRelative(motherHalfCousins, i)" class="close">&times;</span>
                  <small class="text-primary-fh pull-right">Halvsyskonbarn | Tillhör: <strong>{{ getNameByNode(mhc.familyTreeParentNode) }}</strong></small>
                  <label>Förnamn</label>
                  <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Förnamn"
                    v-model="mhc.firstName" v-on:keypress="isLetterOrHyphen($event)" />
                  <div class="clearfix"></div>
                  <label>Efternamn</label>
                  <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Efternamn"
                    v-model="mhc.lastName" v-on:keypress="isLetterOrHyphen($event)" />
                  <div class="clearfix"></div>
                  <label for="btn-group">Är halvsyskonets barn i livet?</label><br />
                  <div class="btn-group btn-group-toggle" style="display: flex">
                    <label class="btn btn-outline-secondary btn-lg btn-override btn-alive" style="background: #fff"
                      :class="mhc.alive === true ? 'active': ''">
                      <input type="radio" v-model="mhc.alive" v-bind:value="true" autocomplete="off">Ja
                    </label>
                    <label class="btn btn-outline-secondary btn-lg btn-override btn-alive" style="background: #fff"
                      :class="mhc.alive === false ? 'active': ''">
                      <input type="radio" v-model="mhc.alive" v-bind:value="false" autocomplete="off">Nej
                    </label>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block add-motherhalfsiblings-btn" @click="addMotherHalfSibling()">
            Lägg till halvsyskon
          </button>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block btn-finish-relation"
            @click="finishedRelation('motherhalfsiblings')"
            :disabled="dirty"
            v-if="motherHalfSiblings.length >= 1">
            Klar
          </button>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block"
            v-if="motherHalfSiblings.length < 1" @click="noRelatives('motherhalfsiblings')">
            Inga halvsyskon på mammas sida
          </button>
        </div>
        <!-- Halvsyskon på pappas sida -->
        <div class="col-md-6" v-if="type === 'fatherhalfsiblings'">
          <h2 class="text-primary-fh left-header" v-html="data.familytreedashboard.buildfatherhalfsiblingsheader"></h2>
          <p v-html="data.familytreedashboard.buildFatherhalfsiblingsText"></p>
          <div class="card-preview" v-if="fatherHalfSiblings.length < 1">
            <h5 class="text-center card-preview-header">Inga halvsyskon på pappas sida tillagda</h5>
          </div>
          <!-- Om man har halvsyskon -->
          <div>
            <div class="parent" v-for="(fhs, i) in fatherHalfSiblings" v-bind:key="i">
              <div class="card fatherhalfsiblings-card">
                <div class="card-body">
                  <span v-on:click="removeRelative(fatherHalfSiblings, i)" class="close">&times;</span>
                  <small class="text-primary-fh pull-right">Halvsyskon</small>
                  <label>Förnamn</label>
                  <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Förnamn"
                    v-model="fhs.firstName" v-on:keypress="isLetterOrHyphen($event)" />
                  <div class="clearfix"></div>
                  <label>Efternamn</label>
                  <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Efternamn"
                    v-model="fhs.lastName" v-on:keypress="isLetterOrHyphen($event)" />
                  <div class="clearfix"></div>
                  <label for="btn-group">Är halvsyskonet i livet?</label><br />
                  <div class="btn-group btn-group-toggle" style="display: flex">
                    <label class="btn btn-outline-secondary btn-lg btn-override btn-alive" style="background: #fff"
                      :class="fhs.alive === true ? 'active': ''">
                      <input type="radio" v-model="fhs.alive" v-bind:value="true" autocomplete="off">Ja
                    </label>
                    <label class="btn btn-outline-secondary btn-lg btn-override btn-alive" style="background: #fff"
                      :class="fhs.alive === false ? 'active': ''">
                      <input type="radio" v-model="fhs.alive" v-bind:value="false" autocomplete="off">Nej
                    </label>
                  </div>
                  <div class="clearfix"></div>
                  <button class="btn btn-primary btn-lg btn-block add-fatherhalfcousins-btn" @click="addFatherHalfCousin(i)">
                    Lägg till barn till halvsyskon
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="parent" v-for="(fhc, i) in fatherHalfCousins" v-bind:key="i">
              <div class="card override-card">
                <div class="card-body override-card-body">
                  <span v-on:click="removeRelative(fatherHalfCousins, i)" class="close">&times;</span>
                  <small class="text-primary-fh pull-right">Halvsyskonbarn | Tillhör: <strong>{{ getNameByNode(fhc.familyTreeParentNode) }}</strong></small>
                  <label>Förnamn</label>
                  <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Förnamn"
                    v-model="fhc.firstName" v-on:keypress="isLetterOrHyphen($event)" />
                  <div class="clearfix"></div>
                  <label>Efternamn</label>
                  <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Efternamn"
                    v-model="fhc.lastName" v-on:keypress="isLetterOrHyphen($event)" />
                  <div class="clearfix"></div>
                  <label for="btn-group">Är halvsyskonets barn i livet?</label><br />
                  <div class="btn-group btn-group-toggle" style="display: flex">
                    <label class="btn btn-outline-secondary btn-lg btn-override btn-alive" style="background: #fff"
                      :class="fhc.alive === true ? 'active': ''">
                      <input type="radio" v-model="fhc.alive" v-bind:value="true" autocomplete="off">Ja
                    </label>
                    <label class="btn btn-outline-secondary btn-lg btn-override btn-alive" style="background: #fff"
                      :class="fhc.alive === false ? 'active': ''">
                      <input type="radio" v-model="fhc.alive" v-bind:value="false" autocomplete="off">Nej
                    </label>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block add-fatherhalfsiblings-btn" @click="addFatherHalfSibling()">
            Lägg till halvsyskon
          </button>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block btn-finish-relation" :disabled="dirty"
            @click="finishedRelation('fatherhalfsiblings')" v-if="fatherHalfSiblings.length >= 1">
            Klar
          </button>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block"
            v-if="fatherHalfSiblings.length < 1" @click="noRelatives('fatherhalfsiblings')">
            Inga halvsyskon på pappas sida
          </button>
        </div>
        <!-- Syskon & kusiner på mammas sida -->
        <div class="col-md-6" v-if="type === 'mothercousins'">
          <h2 class="text-primary-fh left-header" v-html="data.familytreedashboard.buildmothercousinsheader"></h2>
          <p v-html="data.familytreedashboard.buildMothercousinsText"></p>
          <div class="card-preview" v-if="motherSiblings.length < 1">
            <h5 class="text-center card-preview-header">Inga syskon på mammas sida tillagda</h5>
          </div>
          <!-- Om mamma har syskon -->
          <div>
            <div class="parent" v-for="(momSibling, i) in motherSiblings" v-bind:key="i">
              <div class="card mothersiblings-card">
                <div class="card-body">
                  <span v-on:click="removeRelative(motherSiblings, i)" class="close">&times;</span>
                  <small class="text-primary-fh pull-right">Syskon till mamma</small>
                  <label>Förnamn</label>
                  <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Förnamn"
                    v-model="momSibling.firstName" v-on:keypress="isLetterOrHyphen($event)" />
                  <div class="clearfix"></div>
                  <label>Efternamn</label>
                  <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Efternamn"
                    v-model="momSibling.lastName" v-on:keypress="isLetterOrHyphen($event)" />
                  <div class="clearfix"></div>
                  <label for="btn-group">Är syskonet till mamma i livet?</label><br />
                  <div class="btn-group btn-group-toggle" style="display: flex">
                    <label class="btn btn-outline-secondary btn-lg btn-override btn-alive" style="background: #fff"
                      :class="momSibling.alive === true ? 'active': ''">
                      <input type="radio" v-model="momSibling.alive" v-bind:value="true" autocomplete="off">Ja
                    </label>
                    <label class="btn btn-outline-secondary btn-lg btn-override btn-alive" style="background: #fff"
                      :class="momSibling.alive === false ? 'active': ''">
                      <input type="radio" v-model="momSibling.alive" v-bind:value="false" autocomplete="off">Nej
                    </label>
                  </div>
                  <div class="clearfix"></div>
                  <button class="btn btn-primary btn-lg btn-block add-mothercousin-btn" @click="addMotherCousin(i)">
                    Lägg till kusin
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="parent" v-for="(momCousin, i) in motherCousins" v-bind:key="i">
              <div class="card override-card">
                <div class="card-body override-card-body">
                  <span v-on:click="removeRelative(motherCousins, i)" class="close">&times;</span>
                  <small class="text-primary-fh pull-right">Kusin | Tillhör: <strong>{{ getNameByNode(momCousin.familyTreeParentNode) }}</strong></small>
                  <label>Förnamn</label>
                  <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Förnamn"
                    v-model="momCousin.firstName" v-on:keypress="isLetterOrHyphen($event)" />
                  <div class="clearfix"></div>
                  <label>Efternamn</label>
                  <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Efternamn"
                    v-model="momCousin.lastName" v-on:keypress="isLetterOrHyphen($event)" />
                  <div class="clearfix"></div>
                  <label for="btn-group">Är kusinen i livet?</label><br />
                  <div class="btn-group btn-group-toggle" style="display: flex">
                    <label class="btn btn-outline-secondary btn-lg btn-override btn-alive"
                      style="background: #fff" :class="momCousin.alive === true ? 'active': ''">
                      <input type="radio" v-model="momCousin.alive" v-bind:value="true" autocomplete="off">Ja
                    </label>
                    <label class="btn btn-outline-secondary btn-lg btn-override btn-alive"
                      style="background: #fff" :class="momCousin.alive === false ? 'active': ''">
                      <input type="radio" v-model="momCousin.alive" v-bind:value="false" autocomplete="off">Nej
                    </label>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block add-mothersibling-btn" @click="addMotherSibling()">
            Lägg till syskon på mammas sida
          </button>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block btn-finish-relation" :disabled="dirty"
            @click="finishedRelation('mothercousins')" v-if="motherSiblings.length >= 1">
            Klar
          </button>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block"
            v-if="motherSiblings.length < 1" @click="noRelatives('mothercousins')">
          Inga syskon på mammas sida
          </button>
        </div>
        <!-- Kusiner på pappas sida -->
        <div class="col-md-6" v-if="type === 'fathercousins'">
          <h2 class="text-primary-fh left-header" v-html="data.familytreedashboard.buildfathercousinsheader"></h2>
          <p v-html="data.familytreedashboard.buildFathercousinsText"></p>
          <div class="card-preview" v-if="fatherSiblings.length < 1">
            <h5 class="text-center card-preview-header">Inga syskon på pappas sida tillagda</h5>
          </div>
          <!-- Om pappa har syskon -->
          <div>
            <div class="parent" v-for="(dadSibling, i) in fatherSiblings" v-bind:key="i">
              <div class="card fathersiblings-card">
                <div class="card-body">
                  <span v-on:click="removeRelative(fatherSiblings, i)" class="close">&times;</span>
                  <small class="text-primary-fh pull-right">Syskon till pappa</small>
                  <label>Förnamn</label>
                  <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Förnamn"
                    v-model="dadSibling.firstName" v-on:keypress="isLetterOrHyphen($event)" />
                  <div class="clearfix"></div>
                  <label>Efternamn</label>
                  <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Efternamn"
                    v-model="dadSibling.lastName" v-on:keypress="isLetterOrHyphen($event)" />
                  <div class="clearfix"></div>
                  <label for="btn-group">Är syskonet till pappa i livet?</label><br />
                  <div class="btn-group btn-group-toggle" style="display: flex">
                    <label class="btn btn-outline-secondary btn-lg btn-override btn-alive" style="background: #fff"
                      :class="dadSibling.alive === true ? 'active': ''">
                      <input type="radio" v-model="dadSibling.alive" v-bind:value="true" autocomplete="off">Ja
                    </label>
                    <label class="btn btn-outline-secondary btn-lg btn-override btn-alive" style="background: #fff"
                      :class="dadSibling.alive === false ? 'active': ''">
                      <input type="radio" v-model="dadSibling.alive" v-bind:value="false" autocomplete="off">Nej
                    </label>
                  </div>
                  <div class="clearfix"></div>
                  <button class="btn btn-primary btn-lg btn-block add-fathercousin-btn" @click="addFatherCousin(i)">
                    Lägg till kusin
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="parent" v-for="(dadCousin, i) in fatherCousins" v-bind:key="i">
              <div class="card override-card">
                <div class="card-body override-card-body">
                  <span v-on:click="removeRelative(fatherCousins, i)" class="close">&times;</span>
                  <small class="text-primary-fh pull-right">Kusin | Tillhör: <strong>{{ getNameByNode(dadCousin.familyTreeParentNode) }}</strong></small>
                  <label>Förnamn</label>
                  <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Förnamn"
                    v-model="dadCousin.firstName" v-on:keypress="isLetterOrHyphen($event)" />
                  <div class="clearfix"></div>
                  <label>Efternamn</label>
                  <input class="form-control form-control-lg name-input" type="text" @input="checkInputs()" placeholder="Efternamn"
                    v-model="dadCousin.lastName" v-on:keypress="isLetterOrHyphen($event)" />
                  <div class="clearfix"></div>
                  <label for="btn-group">Är kusinen i livet?</label><br />
                  <div class="btn-group btn-group-toggle" style="display: flex">
                    <label class="btn btn-outline-secondary btn-lg btn-override btn-alive"
                      style="background: #fff" :class="dadCousin.alive === true ? 'active': ''">
                      <input type="radio" v-model="dadCousin.alive" v-bind:value="true" autocomplete="off">Ja
                    </label>
                    <label class="btn btn-outline-secondary btn-lg btn-override btn-alive"
                      style="background: #fff" :class="dadCousin.alive === false ? 'active': ''">
                      <input type="radio" v-model="dadCousin.alive" v-bind:value="false" autocomplete="off">Nej
                    </label>
                  </div>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block add-fathersibling-btn" @click="addFatherSibling()">
            Lägg till syskon på pappas sida
          </button>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block btn-finish-relation" :disabled="dirty"
            @click="finishedRelation('fathercousins')" v-if="fatherSiblings.length >= 1">
            Klar
          </button>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-lg btn-block"
            v-if="fatherSiblings.length < 1" @click="noRelatives('fathercousins')">
            Inga syskon på pappas sida
          </button>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm">
        </div>
        <div class="col-md-6">
          <div class="clearfix"></div>
          <button class="btn btn-outline-secondary btn-lg btn-block" @click="$router.go(-1)">
            &#8592; Tillbaka
          </button>
        </div>
        <div class="col-sm">
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import { request } from '../plugins/datocms'
import config from '../../config/index.js'
import generateUUID from '../plugins/guid'
import axios from '../plugins/axios'
import $ from 'jquery'

export default {
  name: 'ftbuild',
  components: {
    Top,
    Bottom
  },
  data () {
    return {
      data: null,
      relatives: null,
      loader: null,
      dirty: false,
      minorAge: null,
      parents: {
        mother: {
          firstName: '',
          lastName: '',
          alive: null,
          familyRelation: 1,
          familyTreeNode: generateUUID(),
          familyTreeParentNode: null
        },
        father: {
          firstName: '',
          lastName: '',
          alive: null,
          familyRelation: 2,
          familyTreeNode: generateUUID(),
          familyTreeParentNode: null
        }
      },
      grandParents: {
        grandmother: {
          firstName: '',
          lastName: '',
          alive: null,
          familyRelation: 3,
          familyTreeNode: generateUUID(),
          familyTreeParentNode: null
        },
        grandfather: {
          firstName: '',
          lastName: '',
          alive: null,
          familyRelation: 4,
          familyTreeNode: generateUUID(),
          familyTreeParentNode: null
        },
        grandma: {
          firstName: '',
          lastName: '',
          alive: null,
          familyRelation: 5,
          familyTreeNode: generateUUID(),
          familyTreeParentNode: null
        },
        grandpa: {
          firstName: '',
          lastName: '',
          alive: null,
          familyRelation: 6,
          familyTreeNode: generateUUID(),
          familyTreeParentNode: null
        }
      },
      children: [],
      grandChildren: [],
      siblings: [],
      siblingsChildren: [],
      motherHalfSiblings: [],
      motherHalfCousins: [],
      fatherHalfSiblings: [],
      fatherHalfCousins: [],
      motherSiblings: [],
      motherCousins: [],
      fatherSiblings: [],
      fatherCousins: []
    }
  },
  props: ['type'],
  methods: {
    checkInputs () {
      if (this.type !== 'parents') {
        setTimeout(() => {
          var inputs = document.getElementsByClassName('name-input')
          for (var i = 0; i < inputs.length; i += 1) {
            if (inputs[i].value === '' || inputs[i].value.length < 2 || /[a-zA-Z]/.test(inputs[i].value) === false) {
              this.dirty = true
              break
            } else {
              this.dirty = false
            }
          }
        }, 100)
      }
    },
    isLetterOrHyphen (e) {
      const char = String.fromCharCode(e.keyCode)
      if (/^[A-Za-z-\såäöÅÄÖ]+$/.test(char)) {
        return true
      } else {
        e.preventDefault()
      }
    },
    getNameByNode (node) {
      let result = ''
      const mergedArr = this.children.concat(
        this.grandChildren, this.siblings, this.siblingsChildren,
        this.motherHalfSiblings, this.motherHalfCousins, this.fatherHalfSiblings,
        this.fatherHalfCousins, this.motherSiblings, this.motherCousins,
        this.fatherSiblings, this.fatherCousins
      )
      mergedArr.forEach(r => {
        if (node === r.familyTreeNode) {
          result = r.firstName + ' ' + r.lastName
        }
      })
      return result
    },
    removeRelative (relatives, i) {
      const r = confirm('Är du säker på att du vill ta bort denna släkting?')
      if (r) {
        if (relatives) {
          relatives.splice(i, 1)
          this.checkInputs()
        }
      }
    },
    noRelatives (familyRelation) {
      switch (familyRelation) {
        case 'children':
          sessionStorage.setItem('nochildren', true)
          this.$router.push('/familytree')
          break
        case 'siblings':
          sessionStorage.setItem('nosiblings', true)
          this.$router.push('/familytree')
          break
        case 'motherhalfsiblings':
          sessionStorage.setItem('nomotherhalfsiblings', true)
          this.$router.push('/familytree')
          break
        case 'fatherhalfsiblings':
          sessionStorage.setItem('nofatherhalfsiblings', true)
          this.$router.push('/familytree')
          break
        case 'mothercousins':
          sessionStorage.setItem('nomothercousins', true)
          this.$router.push('/familytree')
          break
        case 'fathercousins':
          sessionStorage.setItem('nofathercousins', true)
          this.$router.push('/familytree')
          break
        default:
          console.log('Error: Could not set a relation in the noRelatives function.')
      }
    },
    scrollToElement () {
      const nodes = document.querySelectorAll('div.parent')
      if (nodes.length > 0) {
        nodes[nodes.length - 1].scrollIntoView({behavior: 'smooth', block: 'start'})
      }
    },
    addChild () {
      const child = {
        firstName: '',
        lastName: '',
        alive: true,
        familyRelation: 7,
        familyTreeNode: generateUUID(),
        familyTreeParentNode: null
      }
      this.children.push(child)
      this.scrollToElement()
      this.checkInputs()
    },
    addGrandChild (i) {
      const grandChild = {
        firstName: '',
        lastName: '',
        alive: true,
        familyRelation: 8,
        familyTreeNode: generateUUID(),
        familyTreeParentNode: this.children[i].familyTreeNode
      }
      this.grandChildren.push(grandChild)
      this.scrollToElement()
      this.checkInputs()
    },
    addSibling () {
      const sibling = {
        firstName: '',
        lastName: '',
        alive: true,
        familyRelation: 9,
        familyTreeNode: generateUUID(),
        familyTreeParentNode: null
      }
      this.siblings.push(sibling)
      this.scrollToElement()
      this.checkInputs()
    },
    addSiblingsChild (i) {
      const siblingsChild = {
        firstName: '',
        lastName: '',
        alive: true,
        familyRelation: 10,
        familyTreeNode: generateUUID(),
        familyTreeParentNode: this.siblings[i].familyTreeNode
      }
      this.siblingsChildren.push(siblingsChild)
      this.scrollToElement()
      this.checkInputs()
    },
    addMotherHalfSibling () {
      const halfSibling = {
        firstName: '',
        lastName: '',
        alive: true,
        familyRelation: 11,
        familyTreeNode: generateUUID(),
        familyTreeParentNode: null
      }
      this.motherHalfSiblings.push(halfSibling)
      this.scrollToElement()
      this.checkInputs()
    },
    addMotherHalfCousin (i) {
      const halfCousin = {
        firstName: '',
        lastName: '',
        alive: true,
        familyRelation: 12,
        familyTreeNode: generateUUID(),
        familyTreeParentNode: this.motherHalfSiblings[i].familyTreeNode
      }
      this.motherHalfCousins.push(halfCousin)
      this.scrollToElement()
      this.checkInputs()
    },
    addFatherHalfSibling () {
      const halfSibling = {
        firstName: '',
        lastName: '',
        alive: true,
        familyRelation: 13,
        familyTreeNode: generateUUID(),
        familyTreeParentNode: null
      }
      this.fatherHalfSiblings.push(halfSibling)
      this.scrollToElement()
      this.checkInputs()
    },
    addFatherHalfCousin (i) {
      const halfCousin = {
        firstName: '',
        lastName: '',
        alive: true,
        familyRelation: 14,
        familyTreeNode: generateUUID(),
        familyTreeParentNode: this.fatherHalfSiblings[i].familyTreeNode
      }
      this.fatherHalfCousins.push(halfCousin)
      this.scrollToElement()
      this.checkInputs()
    },
    addMotherSibling () {
      const sibling = {
        firstName: '',
        lastName: '',
        alive: true,
        familyRelation: 15,
        familyTreeNode: generateUUID(),
        familyTreeParentNode: null
      }
      this.motherSiblings.push(sibling)
      this.scrollToElement()
      this.checkInputs()
    },
    addMotherCousin (i) {
      const cousin = {
        firstName: '',
        lastName: '',
        alive: true,
        familyRelation: 17,
        familyTreeNode: generateUUID(),
        familyTreeParentNode: this.motherSiblings[i].familyTreeNode
      }
      this.motherCousins.push(cousin)
      this.scrollToElement()
      this.checkInputs()
    },
    addFatherSibling () {
      const sibling = {
        firstName: '',
        lastName: '',
        alive: true,
        familyRelation: 16,
        familyTreeNode: generateUUID(),
        familyTreeParentNode: null
      }
      this.fatherSiblings.push(sibling)
      this.scrollToElement()
      this.checkInputs()
    },
    addFatherCousin (i) {
      const cousin = {
        firstName: '',
        lastName: '',
        alive: true,
        familyRelation: 18,
        familyTreeNode: generateUUID(),
        familyTreeParentNode: this.fatherSiblings[i].familyTreeNode
      }
      this.fatherCousins.push(cousin)
      this.scrollToElement()
      this.checkInputs()
    },
    getRelatives () {
      let loader = this.$loading.show()
      axios._get(config.relativeUri).then(response => {
        this.relatives = response.data.relatives
        loader.hide()
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get relatives: ' + error)
          loader.hide()
        }
      })
    },
    postRelative (relative) {
      if (relative) {
        axios.postRelative(config.relativeUri, relative).then((response) => {
        }, (error) => {
          if (error.response && error.response.status === 401) {
            window.location.href = window.location.origin.concat('/error')
          } else {
            console.log(error)
          }
        })
      }
    },
    getMinorAgeState () {
      axios._get(config.childrenUnder13Uri).then(response => {
        this.minorAge = response.data.hasChildrenUnder13
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get minor age state: ' + error)
        }
      })
    },
    minorAgedChildren () {
      let loader = this.$loading.show()
      axios.postChildrenUnder13(config.childrenUnder13Uri, this.minorAge).then((response) => {
        if (response) {
          loader.hide()
          this.consentForMinorAgedChildren()
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          loader.hide()
          console.log(error)
        }
      })
    },
    consentForMinorAgedChildren () {
      if (this.minorAge) {
        $('#consentMinorModal').modal()
        $('.modal-open').css('padding-right', '0px')
      } else {
        this.giveConsentFinishRelation(false)
        this.finishedRelation('children')
      }
    },
    giveConsentFinishRelation (consent) {
      axios.postMinorConsent(config.childrenUnder13Uri + config.consentUri, consent).then((response) => {
        if (response) {
          this.finishedRelation('children')
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log(error)
        }
      })
    },
    finishedRelation (familyRelation) {
      let loader = this.$loading.show()
      this.dirty = true // This is to avoid button being undisabled after pressing 'Klar'
      switch (familyRelation) {
        case 'parents':
          var merged = {...this.parents, ...this.grandParents}
          // Returns an array of a given object own enumerable [key, value] pairs
          Object.entries(merged).forEach(([key, parent]) => {
            if (parent.firstName !== '' && parent.lastName !== '') {
              this.postRelative(parent)
            }
          })
          setTimeout(() => {
            loader.hide()
            window.location.href = window.location.origin.concat('/familytree')
          }, 2500)
          break
        case 'children':
          if (this.grandChildren.length > 0) {
            this.children.push(...this.grandChildren)
            this.grandChildren = []
          }
          this.children.forEach(child => {
            this.postRelative(child)
          })
          setTimeout(() => {
            loader.hide()
            window.location.href = window.location.origin.concat('/familytree')
          }, 2500)
          break
        case 'siblings':
          if (this.siblingsChildren.length > 0) {
            this.siblings.push(...this.siblingsChildren)
            this.siblingsChildren = []
          }
          this.siblings.forEach(sibling => {
            this.postRelative(sibling)
          })
          setTimeout(() => {
            loader.hide()
            window.location.href = window.location.origin.concat('/familytree')
          }, 2500)
          break
        case 'motherhalfsiblings':
          if (this.motherHalfCousins.length > 0) {
            this.motherHalfSiblings.push(...this.motherHalfCousins)
            this.motherHalfCousins = []
          }
          this.motherHalfSiblings.forEach(motherhalfsibling => {
            this.postRelative(motherhalfsibling)
          })
          setTimeout(() => {
            loader.hide()
            window.location.href = window.location.origin.concat('/familytree')
          }, 2500)
          break
        case 'fatherhalfsiblings':
          if (this.fatherHalfCousins.length > 0) {
            this.fatherHalfSiblings.push(...this.fatherHalfCousins)
            this.fatherHalfCousins = []
          }
          this.fatherHalfSiblings.forEach(fatherhalfsibling => {
            this.postRelative(fatherhalfsibling)
          })
          setTimeout(() => {
            loader.hide()
            window.location.href = window.location.origin.concat('/familytree')
          }, 2500)
          break
        case 'mothercousins':
          if (this.motherCousins.length > 0) {
            this.motherSiblings.push(...this.motherCousins)
            this.motherCousins = []
          }
          this.motherSiblings.forEach(mothersibling => {
            this.postRelative(mothersibling)
          })
          setTimeout(() => {
            loader.hide()
            window.location.href = window.location.origin.concat('/familytree')
          }, 2500)
          break
        case 'fathercousins':
          if (this.fatherCousins.length > 0) {
            this.fatherSiblings.push(...this.fatherCousins)
            this.fatherCousins = []
          }
          this.fatherSiblings.forEach(fathersibling => {
            this.postRelative(fathersibling)
          })
          setTimeout(() => {
            loader.hide()
            window.location.href = window.location.origin.concat('/familytree')
          }, 2500)
          break
        default:
          console.log('Error: Could not finish a relation in the function finishedRelation.')
      }
    }
  },
  watch: {},
  beforeMount () {
    this.getMinorAgeState()
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          familytreedashboard {
            welcomeHeader
            infoText
            parentsHeader
            childrenHeader
            siblingsHeader
            motherhalfsiblingsHeader
            fatherhalfsiblingsHeader
            mothercousinsHeader
            fathercousinsHeader
            buildParentsText
            buildchildrenheader
            buildChildrenText
            buildsiblingsheader
            buildSiblingsText
            buildmotherhalfsiblingsheader
            buildMotherhalfsiblingsText
            buildfatherhalfsiblingsheader
            buildFatherhalfsiblingsText
            buildmothercousinsheader
            buildMothercousinsText
            buildfathercousinsheader
            buildFathercousinsText
          }
          familytree {
            consentMinorHeader
            consentMinorText
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
label {
  font-size: 0.8em;
}
.add-grandchild-btn, .add-child-btn {
  margin-top: 20px;
}
.container {
  margin-top: 75px;
}
.left-header {
  text-align: left;
}
.pull-right {
  float: right !important;
  margin-right: 1vw;
}
.override-card {
  background: #bae2ef !important;
}
.override-card-body {
  background: #bae2ef !important;
}
.btn-group {
  display: flex;
}
.btn-override {
  border-color: #069ccc;
  background: #fff;
  color: #069ccc;
  font-size: 1em;
}
.btn-finish-relation {
  background: #408A2B !important;
  border-color: #357324 !important;
}
.card {
  border: 2px solid #bae2ef;
  border-radius: 15px;
  margin-top: 2rem;
  text-align: left;
}
.card-body {
  background: #e5f1f5;
  border-radius: 15px;
}
.card-body > .close {
  top: 0;
  right: 0;
  margin: 10px;
  position: absolute;
  cursor: pointer;
}
.card-preview {
  padding: 10px;
  border: 2px solid #bae2ef;
  background: #fff;
}
.card-preview .card-preview-header {
  margin-top: 10px;
  color: #bae2ef;
  opacity: 0.8;
}
.modal h5, p {
  text-align: left;
}
.minor-age-card {
  background: #F7F7F7;
  color: inherit;
  margin: 15px 0 15px 0;
}
.minor-age-card p {
  text-align: center;
  margin-top: 15px;
}
.minor-age-checkbox {
  cursor: pointer;
  transform: scale(1.5);
}
</style>



// WEBPACK FOOTER //
// src/components/FamilyTreeBuild.vue